import { Mountain, Mail, MapPin } from "lucide-react";
import { Link } from "react-router-dom";
import BrandMark from "@/components/BrandMark";
import { useLanguage } from "@/i18n";
import { TOURS } from "@/tours";
import { scrollToId } from "@/components/Navbar";

export default function Footer({ onRequestTour }) {
  const { lang, t } = useLanguage();

  return (
    <footer data-testid="site-footer" className="relative overflow-hidden bg-ink text-[#F3EFE9]">
      <img src="/images/golfo-sera.webp" alt="Il golfo di Napoli di sera con il Vesuvio" className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0 bg-[#0A2233]/50" />
      <div className="absolute inset-0 bg-gradient-to-b from-[#0A2233]/60 via-[#0A2233]/20 to-[#0A2233]/65" />
      <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10 py-16 lg:py-24 grid md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <div className="flex items-center gap-2.5 mb-6">
            <BrandMark className="w-11 h-8" />
            <span className="font-serif text-2xl font-medium tracking-tight">
              Naples <span className="text-[#C9A227] text-[1.35em] leading-none font-light">&amp;</span> <span className="text-[#5BC0BE]">Beyond Tours</span>
            </span>
          </div>
          <p className="text-sm leading-relaxed text-[#F3EFE9]/70 max-w-sm">{t.footer.tagline}</p>
          <button
            data-testid="footer-cta-button"
            onClick={() => scrollToId("#richiedi")}
            className="mt-8 rounded-full border border-[#F3EFE9]/30 px-8 py-3 text-xs font-bold uppercase tracking-[0.15em] hover:bg-[#C9A227] hover:border-[#C9A227] transition-colors duration-300"
          >
            {t.nav.cta}
          </button>
        </div>

        <div className="md:col-span-4">
          <p className="text-xs font-bold uppercase tracking-[0.22em] text-[#F3EFE9]/50 mb-6">{t.footer.toursTitle}</p>
          <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3">
            {TOURS.map((tour) => (
              <li key={tour.slug}>
                <button
                  data-testid={`footer-tour-${tour.slug}`}
                  onClick={() => {
                    onRequestTour(tour[lang].title);
                    scrollToId("#richiedi");
                  }}
                  className="text-sm text-[#F3EFE9]/75 hover:text-[#C9A227] transition-colors duration-300 text-left"
                >
                  {tour[lang].title}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-3">
          <p className="text-xs font-bold uppercase tracking-[0.22em] text-[#F3EFE9]/50 mb-6">{t.footer.contactTitle}</p>
          <a
            data-testid="footer-email-link"
            href={`mailto:${t.footer.email}`}
            className="flex items-center gap-3 text-sm text-[#F3EFE9]/75 hover:text-[#C9A227] transition-colors duration-300 mb-4"
          >
            <Mail className="w-4 h-4 text-[#C9A227]" /> {t.footer.email}
          </a>
          <p className="flex items-center gap-3 text-sm text-[#F3EFE9]/75">
            <MapPin className="w-4 h-4 text-[#C9A227]" /> {t.footer.place}
          </p>
        </div>
      </div>

      <div className="relative border-t border-[#F3EFE9]/10">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-[#F3EFE9]/45">© 2026 Naples &amp; Beyond Tours — {t.footer.rights}</p>
          <Link data-testid="footer-admin-link" to="/admin" className="text-xs text-[#F3EFE9]/45 hover:text-[#C9A227] transition-colors duration-300">
            {t.footer.admin}
          </Link>
        </div>
      </div>
    </footer>
  );
}
